<template>
  <div v-loading="loading" class="evaluation-setting">
    <div v-if="evaluation && evaluation.setting" class="setting">
      <div>
        <el-switch
          :disabled="isDisabledSetting"
          v-model="evaluation.setting.is_self"
          :active-value="true"
          :inactive-value="false"
          active-text="Самооценка"
          @change="updateSetting"
        >
        </el-switch>
        <div style="margin-left: 15px" v-if="evaluation.setting && evaluation.setting.is_self">
          <el-switch
            :disabled="isDisabledSetting"
            v-model="evaluation.setting.use_self_in_result"
            :active-value="true"
            :inactive-value="false"
            active-text="Учитывать самооценку в подсчете результата"
            @change="updateSetting"
          >
          </el-switch>
        </div>
      </div>
      <div>
        <el-switch
          :disabled="isDisabledSetting"
          v-model="evaluation.setting.is_colleague"
          :active-value="true"
          :inactive-value="false"
          active-text="Оценка коллег"
          @change="updateSetting"
        >
        </el-switch>
        <div style="margin-left: 15px" v-if="evaluation.setting && evaluation.setting.is_colleague">
          <p>Количество коллег:</p>
          <el-input
            :disabled="isDisabledSetting"
            placeholder="Количество коллег"
            style="width: 200px"
            :maxlength="6"
            v-model.number="evaluation.setting.colleague_max"
            @input="val => onInputMax(val, 'colleague_max')"
            @change="updateSetting"
          ></el-input>
        </div>
        <div style="margin-left: 15px" v-if="evaluation.setting && evaluation.setting.is_colleague">
          <div>
            <p>Область видимости коллег:</p>
            <el-radio-group
              :disabled="isDisabledSetting"
              v-model="evaluation.setting.colleague_type"
            >
              <el-radio
                key="chief"
                label="chief"
                border
                @change="updateSetting"
              >
                Тот же руководитель
              </el-radio>
              <el-radio
                key="subdivision"
                label="subdivision"
                border
                @change="updateSetting"
              >
                То же подразделение
              </el-radio>
              <el-radio
                key="company"
                label="company"
                border
                @change="updateSetting"
              >
                Та же компания
              </el-radio>
              <el-radio
                key="all"
                label="all"
                border
                @change="updateSetting"
              >
                Все пользователи
              </el-radio>
            </el-radio-group>
          </div>
          <div style="margin-left: 15px;" v-if="evaluation.setting && evaluation.setting.colleague_type === 'chief'">
            <p>Тип руководителя:</p>
            <el-radio-group
              :disabled="isDisabledSetting"
              v-model="evaluation.setting.colleague_chief_type"
            >
              <el-radio
                v-for="type in $companyConfiguration.user.getChiefTypes()"
                :key="type"
                :label="type"
                border
                @change="updateSetting"
              >
                {{ $companyConfiguration.user.getChiefTypeShowName(type) }}
              </el-radio>
            </el-radio-group>
          </div>
          <el-switch
            :disabled="isDisabledSetting"
            v-model="evaluation.setting.is_colleague_approval"
            :active-value="true"
            :inactive-value="false"
            active-text="Подтверждение коллег руководителем"
            @change="updateSetting"
          >
          </el-switch>
          <div style="margin-left: 15px" v-if="evaluation.setting && evaluation.setting.is_colleague_approval">
            <el-switch
              :disabled="isDisabledSetting"
              v-model="evaluation.setting.is_colleague_auto_approval"
              :active-value="true"
              :inactive-value="false"
              active-text="Автоматическое согласование по истечению срока согласования"
              @change="updateSetting"
            >
            </el-switch>
            <div style="margin-left: 15px" v-if="evaluation.setting && evaluation.setting.is_colleague_auto_approval">
              <p>Количество дней на согласование:</p>
              <el-input
                :disabled="isDisabledSetting"
                placeholder="Количество дней"
                style="width: 200px"
                :maxlength="6"
                v-model.number="evaluation.setting.colleague_auto_approval_days"
                @input="val => onInputMax(val, 'colleague_auto_approval_days')"
                @change="updateSetting"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-switch
          :disabled="isDisabledSetting"
          v-model="evaluation.setting.is_subordinate"
          :active-value="true"
          :inactive-value="false"
          active-text="Оценка подчиненных"
          @change="updateSetting"
        >
        </el-switch>
        <div style="margin-left: 15px" v-if="evaluation.setting && evaluation.setting.is_subordinate">
          <p>Тип руководителя:</p>
          <el-radio-group
            :disabled="isDisabledSetting"
            v-model="evaluation.setting.subordinate_type"
          >
            <el-radio
              v-for="type in $companyConfiguration.user.getChiefTypes()"
              :key="type"
              :label="type"
              border
              @change="updateSetting"
            >
              {{ $companyConfiguration.user.getChiefTypeShowName(type) }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div>
        <el-switch
          :disabled="isDisabledSetting"
          v-model="evaluation.setting.is_chief"
          :active-value="true"
          :inactive-value="false"
          active-text="Оценка руководителя"
          @change="updateSetting"
        >
        </el-switch>
        <div style="margin-left: 15px" v-if="evaluation.setting && evaluation.setting.is_chief">
          <p>Тип руководителя:</p>
          <el-radio-group
            :disabled="isDisabledSetting"
            v-model="evaluation.setting.chief_type"
          >
            <el-radio
              v-for="type in $companyConfiguration.user.getChiefTypes()"
              :key="type"
              :label="type"
              border
              @change="updateSetting"
            >
              {{ $companyConfiguration.user.getChiefTypeShowName(type) }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div>
        <el-switch
          v-if="$companyConfiguration.evaluation.isResultSetting()"
          v-model="evaluation.setting.is_result_setting"
          :active-value="true"
          :inactive-value="false"
          active-text="Настроить видимость результатов сотрудником"
          @change="updateSetting"
        >
        </el-switch>
        <div style="margin-left: 15px" v-if="evaluation.setting && evaluation.setting.is_result_setting">
          <div>
            <el-switch
              v-model="evaluation.setting.show_evaluator"
              :active-value="true"
              :inactive-value="false"
              active-text="Разрешить сотруднику видеть оценивающих"
              @change="updateSetting"
            >
            </el-switch>
            <div style="margin-left: 15px"
                 v-if="evaluation.setting && evaluation.setting.is_result_setting && evaluation.setting.show_evaluator">
              <el-switch
                v-model="evaluation.setting.show_evaluator_answers"
                :active-value="true"
                :inactive-value="false"
                active-text="Разрешить сотруднику видеть оценки, выставленные оценивающими"
                @change="updateSetting"
              >
              </el-switch>
            </div>
          </div>
          <div>
            <el-switch
              v-model="evaluation.setting.show_result"
              :active-value="true"
              :inactive-value="false"
              active-text="Разрешить сотруднику видеть результат оценки"
              @change="updateSetting"
            >
            </el-switch>
            <div style="margin-left: 15px" v-if="evaluation.setting && evaluation.setting.is_result_setting && evaluation.setting.show_result">
              <div>
                <el-switch
                  v-model="evaluation.setting.show_main_result"
                  :active-value="true"
                  :inactive-value="false"
                  active-text="Общий средний балл"
                  @change="updateSetting"
                >
                </el-switch>
              </div>
              <div>
                <el-switch
                  v-model="evaluation.setting.show_self_result"
                  :active-value="true"
                  :inactive-value="false"
                  active-text="Самооценки"
                  @change="updateSetting"
                >
                </el-switch>
              </div>
              <div>
                <el-switch
                  v-model="evaluation.setting.show_colleague_result"
                  :active-value="true"
                  :inactive-value="false"
                  active-text="Оценка коллег"
                  @change="updateSetting"
                >
                </el-switch>
              </div>
              <div>
                <el-switch
                  v-model="evaluation.setting.show_subordinate_result"
                  :active-value="true"
                  :inactive-value="false"
                  active-text="Оценка подчиненных"
                  @change="updateSetting"
                >
                </el-switch>
              </div>
              <div>
                <el-switch
                  v-model="evaluation.setting.show_chief_result"
                  :active-value="true"
                  :inactive-value="false"
                  active-text="Оценки руководителя"
                  @change="updateSetting"
                >
                </el-switch>
              </div>
              <div>
                <el-switch
                  v-model="evaluation.setting.show_result_char"
                  :active-value="true"
                  :inactive-value="false"
                  active-text="График"
                  @change="updateSetting"
                >
                </el-switch>
              </div>
              <div>
                <el-switch
                  v-model="evaluation.setting.show_result_competencies"
                  :active-value="true"
                  :inactive-value="false"
                  active-text="Компетенции"
                  @change="updateSetting"
                >
                </el-switch>
              </div>
              <div>
                <el-switch
                  v-model="evaluation.setting.show_result_recommendations"
                  :active-value="true"
                  :inactive-value="false"
                  active-text="Рекомендации"
                  @change="updateSetting"
                >
                </el-switch>
              </div>
              <div>
                <el-switch
                  v-model="evaluation.setting.show_result_strong_sides"
                  :active-value="true"
                  :inactive-value="false"
                  active-text="Сильные стороны"
                  @change="updateSetting"
                >
                </el-switch>
              </div>
              <div>
                <el-switch
                  v-model="evaluation.setting.show_result_comments"
                  :active-value="true"
                  :inactive-value="false"
                  active-text="Комментарии"
                  @change="updateSetting"
                >
                </el-switch>
              </div>
              <div>
                <el-switch
                  v-model="evaluation.setting.show_result_extra_questions"
                  :active-value="true"
                  :inactive-value="false"
                  active-text="Дополнительные вопросы"
                  @change="updateSetting"
                >
                </el-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <eval-scales-select
          :disabled="isDisabledSetting"
          size="size"
          :multiple="false"
          v-model="evaluation.setting.scale_id"
          @change="updateSetting"
        ></eval-scales-select>
      </div>
    </div>
    <div v-if="evaluation && evaluation.setting">
      <p>Дополнительные вопросы</p>
      <el-switch
        style="margin-bottom: 10px"
        v-model="evaluation.setting.is_extra_questions_require"
        :active-value="true"
        :inactive-value="false"
        active-text="Ответ обязателен?"
        @change="updateSetting"
      >
      </el-switch>
      <eval-extra-questions
        :evaluation="evaluation"
      ></eval-extra-questions>
    </div>
  </div>
</template>

<script>
import EvalScalesSelect from "@/modules/evaluation/components/EvalScalesSelect.vue";
import chiefs from "../../../../views/settings/Chiefs.vue";
import EvalExtraQuestions from "@/modules/evaluation/components/evaluation/EvalExtraQuestions.vue";

export default {
  name: 'evaluation-setting',
  computed: {
    chiefs() {
      return chiefs
    }
  },
  components: {EvalExtraQuestions, EvalScalesSelect},
  props: {
    loading: false,
    evaluation: {
      type: Object,
      default: {},
    },
    isDisabledSetting: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateSetting() {
      const colleague_max = this.evaluation.setting.colleague_max;
      if (!Number.isInteger(colleague_max) || colleague_max <= 0) {
        this.evaluation.setting.colleague_max = 1;
      }

      const colleague_auto_approval_days = this.evaluation.setting.colleague_auto_approval_days;
      if (!Number.isInteger(colleague_auto_approval_days) || colleague_auto_approval_days <= 0) {
        this.evaluation.setting.colleague_auto_approval_days = 1;
      }

      this.$api.evaluation.evaluationSettingUpdate({
        ...this.evaluation.setting
      })
    },
    onInputMax(value, field) {
      const digits = String(value).replace(/\D/g, '');
      this.evaluation.setting[field] = digits ? parseInt(digits, 10) : 1;
    },
  },
}
</script>

<style scoped>
  .evaluation-setting {
    .setting div {
      margin-bottom: 10px;
    }
  }
</style>